import { RxArrowTopRight } from "react-icons/rx";

export default function VisaCategory({ category, onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-between w-full p-4 bg-white rounded-lg shadow-custom transition-shadow"
    >
      <span className="md:text-lg text-nowrap overflow-hidden">{category}</span>
      <RxArrowTopRight className="text-gray-900 w-4 md:h-5 h-4 md:w-5" />
    </button>
  )
}
